<template>
  <div>
    <el-dialog :visible.sync="visible" :title="title" custom-class="with-title" :before-close="beforeClose">
      <div class="dialog-content" v-if="!this.messageType">
        <div class="message message-info">メッセージのタイプを選択してください。</div>
        <div class="select-message" layout="row">
          <div @click="changeMessageType('win')">
            <el-card>
              <h3>当選メッセージ</h3>
            </el-card>
          </div>
          <div @click="changeMessageType('lose')">
            <el-card>
              <h3>落選メッセージ</h3>
            </el-card>
          </div>
        </div>
      </div>
      <instantwin-message-add-edit
        v-if="messageType"
        :messageType="messageType"
        :messageId="messageId"
        :mode="mode"
        :visible="visible"
        :isChangeWithoutSubmit.sync="isChangeWithoutSubmit"
        @close="close"
      ></instantwin-message-add-edit>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.select-message {
  margin-top: $spacing-unit * 2;

  & > div {
    width: 100%;

    .el-card {
      height: 100%;

      &[disabled] {
        cursor: not-allowed;
      }

      &:hover {
        border-color: $primary-color;
      }
    }

    &:hover {
      cursor: pointer;
    }

    h3 {
      text-align: center;
    }

    &:first-child {
      margin-right: $spacing-unit;
    }

    &:last-child {
      margin-left: $spacing-unit;
    }
  }
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'

import InstantwinMessageAddEdit from '@/client/features/twitter_instantwin_message/instantwin_message_add_edit'

export default defineComponent({
  components: {
    InstantwinMessageAddEdit
  },
  data() {
    return {
      visible: false,
      title: '',
      mode: '',
      messageId: 0,
      messageType: '',
      isChangeWithoutSubmit: false
    }
  },
  methods: {
    /**
     * ダイアログを開く
     */
    async open(type: string, messageId: number, messageType = '') {
      this.visible = true
      this.messageType = messageType
      switch (type) {
        case 'edit':
          this.mode = 'edit'
          this.messageId = messageId
          this.title = 'test'
          if (messageType === 'win') {
            this.title = '自動配信メッセージ(当選)の編集'
          } else {
            this.title = '自動配信メッセージ(落選)の編集'
          }
          break
        case 'copy':
          this.mode = 'add'
          this.messageId = messageId
          this.title = '自動配信メッセージ'
          this.changeMessageType(this.messageType)
          break
        default:
          this.mode = 'add'
          this.title = '自動配信メッセージ'
          this.changeMessageType(this.messageType)
          break
      }
    },

    close() {
      this.visible = false
      this.title = ''
      this.mode = ''
      this.messageId = 0
      this.messageType = ''
      this.isChangeWithoutSubmit = false
    },

    beforeClose() {
      if (!this.isChangeWithoutSubmit) {
        return this.close()
      }

      const confirm = window.confirm('編集内容が保存されていません。ダイアログを閉じてよろしいですか?')

      if (!confirm) {
        return
      }

      this.close()
    },

    /**
     * 種別選択
     * @param {string} type
     */
    changeMessageType(type: string) {
      this.messageType = type
      if (type === 'win') {
        this.title = this.title + '(当選)の新規作成'
      } else if (type === 'lose') {
        this.title = this.title + '(落選)の新規作成'
      }
    }
  }
})
</script>
